import { inject, Injectable } from '@angular/core';
import { DecimalMarker } from '../enums';
import { Mask } from '../interfaces';
import { TranslateService } from '@ngx-translate/core';
import { LodashService } from './lodash.service';

@Injectable({
    providedIn: 'root'
})
export class MaskService {
    private translateService = inject(TranslateService);

    public getLimitedTextMask(options?: { numberOfLetters?: number; suffix?: string; prefix?: string }): Mask {
        const { numberOfLetters, suffix, prefix } = options || {};
        const customPatterns = {
            Z: {
                pattern: new RegExp('.'),
                optional: true
            }
        };

        const pattern = numberOfLetters && numberOfLetters > 0 ? `Z{${numberOfLetters}}` : 'Z*';
        const mask = { pattern, customPatterns, dropSpecialCharacters: false, suffix, prefix };
        return this.addDefaults(mask);
    }

    public getNumericMask(options?: {
        separatorLimit?: string;
        numberOfDecimals?: string;
        decimalMarker?: DecimalMarker;
        suffix?: string;
        prefix?: string;
    }): Mask {
        const numberOfDecimals = options?.numberOfDecimals || '0';
        const separatorLimit = options?.separatorLimit || '';
        const decimalMarker = options?.decimalMarker || DecimalMarker.Coma;
        const suffix = options?.suffix;
        const prefix = options?.prefix;

        const mask: Mask = {
            pattern: `separator.${numberOfDecimals}`,
            decimalMarker: decimalMarker as ',' | '.',
            separatorLimit,
            suffix,
            prefix
        };
        return this.addDefaults(mask);
    }

    public addDefaults(source: Partial<Mask> = {}): Mask {
        return {
            ...source,
            separatorLimit: source.separatorLimit || null,
            decimalMarker: source.decimalMarker || DecimalMarker.Coma,
            dropSpecialCharacters: LodashService.isNil(source.dropSpecialCharacters) ? true : source.dropSpecialCharacters,
            customPatterns: source.customPatterns || null,
            pattern: source.pattern || '',
            suffix: source.suffix ? ' ' + this.translateService.instant(source.suffix) : '',
            prefix: source.prefix ? this.translateService.instant(source.prefix) + ' ' : ''
        };
    }
}
